import moment from 'moment';
import  global_axios  from '../funciones_globales/interaccionapi';
import { completar_String, formatearNumeroEntero } from './format';
import { getItemDatosSesion } from './manejosesion';
import { formatearFechaMoment_a_String }  from './format';

export const get_FechaLocalActual = () => {
    let fecha = new Date();
    return completar_String(fecha.getDate().toString(), '0', 2) + '/' + completar_String((fecha.getMonth()+1).toString(), '0', 2) + '/' + fecha.getFullYear();
}

export const get_FechaSistema_FormatoDate = () =>  {
    let fecha = getItemDatosSesion('fechasistema').toString().split("/");
    return new Date(fecha[2], fecha[1], fecha[0]);
}

export const get_FechaSistema_FormatoString = () =>  {
    return getItemDatosSesion('fechasistema').toString();
}

export const get_MesActual = () =>  {
    return getItemDatosSesion('fechasistema').toString().substring(3,5);
}

export const convertirFechaStringtoDate = (par_st_fecha) => {
    let st_fecha = par_st_fecha.toString().split("/");
    return new Date(st_fecha[2], st_fecha[1], st_fecha[0]);
}

export const esNumeroEntero = (numero) => {
    if (parseFloat(numero) % 1 === 0) {
        return true;
     } else {
        return false;
     }
}

export const esNumero = (numero) => {
    return !isNaN(parseFloat(numero)) && isFinite(numero);
}

export const esEmailValido = (email) => {
    if (email !== '' && email !== null){
        let posArroba = email.indexOf("@");
        let posPunto = email.lastIndexOf(".");
        if (posArroba<1 || posPunto<posArroba+2 || posPunto+2>=email.length) {            
            return false;
        }else{
            return true;
        }
    }else{
        return false;
    }
}

export const validarCampoString = (str, minLength=1, maxLength=minLength) => {
    if (str !== undefined && str !== null && str !== '') {
        if (str.toString().trim().length >= minLength && str.toString().trim().length <= maxLength) {
            return true;
        }
    }
    return false;
}

export const validarStringConAnchoMinimo = (str, minLength) => {
    if (str !== undefined && str !== null && str !== ''){
        if (str.toString().trim().length >= minLength){
            return true;
        }
    }
    return false;
}

export const validarFechaMomentEnFormatoString = (fecha)=>{
    if (!validarCampoString(fecha, 10)){
        return false;
    }
    let fechaValue = moment(fecha, 'DD/MM/YYYY');
    return fechaValue.isValid();
}

export const validarFechaTransaccionSeleccionada = (fechaSeleccionada, fechaProceso, variacionDias) => {
    let resultadoValidacion = {};
    let diasVariacionPermitidos = formatearNumeroEntero(variacionDias)*-1;
    if (fechaSeleccionada.isValid()){
        if(fechaProceso.isValid()){

            if (fechaSeleccionada.diff(fechaProceso, 'days')>0){
                resultadoValidacion = {esValida: false, msg: ('La fecha de transacción seleccionada no puede ser mayor que: ' + formatearFechaMoment_a_String(fechaProceso)) };
            }else{
                let fechaProcesoMinima = fechaProceso.add(diasVariacionPermitidos, 'days');
                if(fechaSeleccionada.diff(fechaProcesoMinima)<0){
                    resultadoValidacion = {esValida: false, msg: ('La fecha de transacción seleccionada no puede ser menor que: ' + formatearFechaMoment_a_String(fechaProcesoMinima)) };
                }else{
                    resultadoValidacion = { esValida: true, msg: 'Fecha Ok'};
                }
            }
        }else{
            resultadoValidacion = { esValida: false, msg: 'La fecha de proceso parametrizada en el módulo es inválida.'};
        }
    }else{
        resultadoValidacion = { esValida: false, msg: 'La fecha de transacción seleccionada es inválida.'};
    }

    return resultadoValidacion;
}

export const validarJSON = (objeto)=>{
    if (objeto === null || objeto === undefined ){
        return false;
    }else{    
        if (Object.keys(objeto).length===0){
            return false;
        }else{
            return true;
        }
    }
}

export const validarPermisoAcceso = (accion, codPermiso) => {
    // Acción: accion => G: Guardar, M: Modificar.
    // Permiso: codPermiso => C: Solo Consulta, G: Consultar y Guardar, M: Consultar, Guardar y Modificar.

    let resultadoValidacion = { esValido: true, msg: 'Permiso Ok'};
    
    if (accion!=='G' && accion!=='M'){
        resultadoValidacion = { esValido: false, msg: 'La acción es incorrecta, no puede continuar.'};
    }    
    if (codPermiso===null || codPermiso===undefined){
        resultadoValidacion = { esValido: false, msg: 'El permiso de acceso en esta sesión es indefinido, no puede continuar.'};
    }
    else{
        if (codPermiso==='C'){
            if (accion==='G'){
                resultadoValidacion = { esValido: false, msg: 'No tiene permiso para guardar, no puede continuar.'};
            }else{
                resultadoValidacion = { esValido: false, msg: 'No tiene permiso para modificar, no puede continuar.'};
            }
        }else{
            if(codPermiso==='G'){
                if (accion==='M'){
                    resultadoValidacion = { esValido: false, msg: 'No tiene permiso para modificar, no puede continuar.'};
                }
            }            
        }
    }

    return resultadoValidacion;
}

//PARAMETRO: ID EMPRESA, Fecha recibo, fecha proceso (FECHAS = STRING, DD/MM/YYYY)
export const validarFechaCierreCartera = (empresa, fechaRecibo, fechaProceso)=>{
    return new Promise((resolve, reject) => {
        global_axios.get('/cierrecartera?empresa='+empresa)
        .then((response)=>{
            let respuesta = {};
            let cierre = response.data
            let fechaUso;

            if(cierre.CierreCartera===null){
                //SOLO PERMITE TRANSACCIONES DEL MES EN CURSO
                let fechaformat= fechaProceso.split('/');
                fechaUso = `01/${fechaformat[1]}/${fechaformat[2]}`
                let diff = moment(fechaUso, 'DD/MM/YYYY').diff(moment(fechaRecibo,'DD/MM/YYYY'),'days' )
                let limiteSuperior = formatearFechaMoment_a_String( moment(fechaUso, 'DD/MM/YYYY').date(0)).split('/')
                limiteSuperior = parseInt(limiteSuperior,10)*-1;
               
                if(diff >= limiteSuperior && diff<=0){ //PONER LIMINTE DINAMICO SEGUN MES
                    respuesta.value = true;
                    respuesta.msg = "- Fecha ok.\n";
                }else if(diff < limiteSuperior || diff > 0){
                    respuesta.value = false;
                    respuesta.msg = '- Fecha del recibo bloqueada por cierre de cartera\n';
                }
            }else{
                //SOLO PERMITE TRANSACCIONES DEL MES ANTERIOR AL MES EN CURSO (CIERRE DE CARTERA)
                fechaUso = cierre.CierreCartera;

                let diff = moment(fechaUso, 'DD/MM/YYYY').diff(moment(fechaRecibo,'DD/MM/YYYY'),'days' )
                const limiteSuperior = formatearFechaMoment_a_String( moment(fechaUso, 'DD/MM/YYYY').date(0)).split('/')
                
                if(diff>=1 && diff<=parseInt(limiteSuperior[0],10)){ //PONER LIMINTE DINAMICO SEGUN MES
                    respuesta.value = true;
                    respuesta.msg = "- Fecha ok.\n";
                }else if(diff <=0 || diff>parseInt(limiteSuperior[0],10) ){
                    respuesta.value = false;
                    respuesta.msg = '- Fecha del recibo bloqueada por cierre de cartera\n';
                }
            }
            resolve(respuesta)
        })
        .catch((err)=>{
            reject(err);
        });
    });
}